import React from 'react';
import { LoadingButton } from '@mui/lab';
import {Box, Grid, Button} from '@material-ui/core';
import {OutlinedInput, FormControl, Stack, Snackbar, Alert, LinearProgress, Radio, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import TextField from '@mui/material/TextField';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import CheckIcon from '@mui/icons-material/Check';
import {MetaTags} from 'react-meta-tags';
import axios from 'axios';
import Cookies from 'js-cookie';
import Tooltip from '@mui/material/Tooltip';
import Authorization from '../components/Authorization'; 
import { useSelector } from 'react-redux';
import {API_URL} from '../utils/EnvVars';
import Header from "../common/HeaderMy";
///import moment from 'moment';
import '../styles/bizofficer-a.css';
import 'font-awesome/css/font-awesome.min.css';
import TreeviewKeywords from './TreeviewKeywords';
import TreeviewKeywordSave from './TreeviewKeywordSave';
import TreeviewKeywordAddBulk from './TreeviewKeywordAddBulk';

  var vertical='top',horizontal='center';
  
  export default function Execute() {
	const userObj = useSelector(state => state.userDetails);	
	const isloggedin = Cookies.get('isrwadminloggedin');
	const childRefSave = React.useRef();
	const childRefAddBulk = React.useRef();
	const childRefAuthorization = React.useRef();
	const [privileges, setPrivileges] = React.useState("");
	const [dataLoading, setDataLoading] = React.useState(true);
	const [addBtnLoading, setAddBtnLoading] = React.useState(false);
	const [deleteDialogShow, setDeleteDialogShow] = React.useState(false);
  	const [deleteBtnLoading, setDeleteBtnLoading] = React.useState(false);
	const [rows, setRows] = React.useState([]);

	//const [open, setOpen] = React.useState(false); 

	const [keyword, setKeyword] = React.useState("");
	const [treeview, setTreeview] = React.useState([]);
	const [selectedIndex, setSelectedIndex] = React.useState(-1);
	const [keywordListObj, setKeywordListObj] = React.useState({});
	const [treeTopicObj, setTreeTopicObj] = React.useState({});

	const [severityAlert, setSeverityAlert] = React.useState("error");
	const [showAlert, setShowAlert] = React.useState(false);
	const [alertMessage, setAlertMessage] = React.useState("");
  

	var myCurrentDate=new Date();
	var myPastFromDate=new Date(myCurrentDate);
    myPastFromDate.setDate(myPastFromDate.getDate() - 366);

	function hideAlert(){
		setShowAlert(false);
	}

	
	  const handleListItemClick = (event, index, obj) => {
		setSelectedIndex(index);
		setKeywordListObj(obj);
	  };

	// check if logged in
	React.useEffect(() => {
		if(!isloggedin){
			window.location.href='login';
		}
	}, [isloggedin]);

	React.useEffect(() => {		
		if(userObj.loginId && userObj.fullName && userObj.token){
			getApiTreeview(userObj.loginId,userObj.fullName,userObj.token);
		}
	}, [userObj]);

	React.useEffect(() => {		
		if(userObj.loginId && userObj.fullName && userObj.token){
			getApiKeywordList(userObj.loginId,userObj.fullName,userObj.token);
		}
	}, [userObj, keyword]);


	async function getApiKeywordList(uid,fullName,token){ 
		  let apiUrl=API_URL+'/crm-keywords?sorting=keywordName&keyword='+keyword;
		  let axiosHeader = {
					'Content-Type': 'multipart/mixed',
					'device': 'web',
					'uid': uid,
					'fullName': fullName,
					'token': token,
			};
			const config = {
				method: 'get',
				url: apiUrl,
				headers: axiosHeader
			}
			setDataLoading(true);
			await axios(config)
			   .then(response => {
				setDataLoading(false);
				if(response && response.data && response.data.responseTxt==="success"){
				 	if(response.data.list && response.data.list.length>0){
						setRows(response.data.list);
					}	
					setPrivileges(response.data.privileges);			 				
				}else if(response && response.data && response.data.responseTxt==="invalidtoken"){
					window.location.href='invalidtoken';
				}else if(response && response.data && response.data.responseTxt==="NoAuthorization"){
					childRefAuthorization.current.handleClickOpen();
				}
			}).catch((error) => {
				console.log("ERROR: ", error);
			})
	}

	async function getApiTreeview(uid,fullName,token){ 
		let apiUrl=API_URL+'/crm-keywords-treeview?parentId=0';
		let axiosHeader = {
				  'Content-Type': 'multipart/mixed',
				  'device': 'web',
				  'uid': uid,
				  'fullName': fullName,
				  'token': token,
		  };
		  const config = {
			  method: 'get',
			  url: apiUrl,
			  headers: axiosHeader
		  }
		  setDataLoading(true);
		  await axios(config)
			 .then(response => {
			  setDataLoading(false);
			  if(response && response.data && response.data.responseTxt==="success"){  
				  if(response.data.obj.list && response.data.obj.list.length>0){
					///document.write(JSON.stringify(response.data.obj.list));
					setTreeview(response.data.obj.list);	
				  }	
				  //  setPrivileges(response.data.privileges);			 				
			  }else if(response && response.data && response.data.responseTxt==="invalidtoken"){
				  window.location.href='invalidtoken';
			  }else if(response && response.data && response.data.responseTxt==="NoAuthorization"){
				  childRefAuthorization.current.handleClickOpen();
			  }
		  }).catch((error) => {
			console.log("ERROR: ", error);
			})
  	}

	
	// function deleteDialogHide(){
	// 	setDeleteDialogShow(false);
	// }

	function selectTreeTopic(obj) {
		if(obj && obj.id>0){
		  setTreeTopicObj(obj);
		}   
	}

	function unselectTopic() {
		setTreeTopicObj({});
	}

	function editTopic() {
		childRefSave.current.handleClickOpen();
	}
	
	function addBulk() {
		childRefAddBulk.current.handleClickOpen();
	}


	  function addTopic(){    
    
		if(selectedIndex<0){
		  setSeverityAlert("error");
		  setShowAlert(true);
		  setAlertMessage("Select keyword");			
		  return false;
		}  
		
		if(selectedIndex>-1 && rows && rows.length>0 && keywordListObj && keywordListObj.autoId>0){ 
		  		setAddBtnLoading(true);
				let axiosHeader = {
					headers: {
						'Content-Type': 'multipart/mixed',
				  		'device': 'web',
				  		'uid': userObj.loginId,
				  		'fullName': userObj.fullName,
				  		'token': userObj.token,
					}
				}; 
		
			const data = new FormData();
			if(treeTopicObj.id>0){
				data.append('keywordId', keywordListObj.autoId);
				data.append('keywordName', keywordListObj.keywordName);
				data.append('keywordUrl', keywordListObj.keywordUrl);
				data.append('parentId', treeTopicObj.id);
			}else{
				data.append('keywordId', keywordListObj.autoId);
				data.append('keywordName', keywordListObj.keywordName);
				data.append('keywordUrl', keywordListObj.keywordUrl);
				data.append('parentId', 0);
			}
	
			axios.post(API_URL+'/crm-create-keywords-treeview', data, axiosHeader)
				.then((response) => {
					setAddBtnLoading(false);
					//console.log("RESPONSE RECEIVED: ", response.data.responseTxt);
					if(response.data.responseTxt==="success"){          
						setSeverityAlert("success");          
						setShowAlert(true);
						setAlertMessage("Keyword name: "+keywordListObj.keywordName+" has been added.");
						if(response.data.obj.list && response.data.obj.list.length>0){
							///document.write(JSON.stringify(response.data.obj.list));
							setTreeview(response.data.obj.list);	
						}	
						setSelectedIndex(-1);
						///setSaveBtn(true);
						return false;
			  
					}else if(response.data.responseTxt==="noSubjectFound"){
								setSeverityAlert("error");
								setShowAlert(true);
								setAlertMessage("No subject found");			
								return false;  
			
					}else if(response.data.responseTxt==="already-added"){
								setSeverityAlert("error");
								setShowAlert(true);
								setAlertMessage("Already added.");			
								return false;  
			
					}else{
						setSeverityAlert("error");
						setShowAlert(true);
						setAlertMessage("Topic could not be added.");			
						return false;
					}
				})
				.catch((error) => {
					console.log("ERROR: ", error);
				})	
			}		
	}
	

	function deleteTopic(){    
    
		if(!treeTopicObj){
		  setSeverityAlert("error");
		  setShowAlert(true);
		  setAlertMessage("Select any tree node to remove");			
		  return false;
		}  
		
			if(treeTopicObj && treeTopicObj.id>0){ 
		  		setDeleteBtnLoading(true);
				let axiosHeader = {
					headers: {
						'Content-Type': 'multipart/mixed',
				  		'device': 'web',
				  		'uid': userObj.loginId,
				  		'fullName': userObj.fullName,
				  		'token': userObj.token,
					}
				}; 
				const data = new FormData();
				data.append('id', treeTopicObj.id);

				axios.post(API_URL+'/crm-delete-keywords-treeview', data, axiosHeader)
				.then((response) => {
					setDeleteBtnLoading(false);
					//console.log("RESPONSE RECEIVED: ", response.data.responseTxt);
					if(response.data.responseTxt==="success"){
						setTreeTopicObj({});
						setDeleteDialogShow(false);
						setSeverityAlert("success");          
						setShowAlert(true);
						if(treeTopicObj){
							setAlertMessage(treeTopicObj.title+" has been removed.");
						}else{
							setAlertMessage("Keyword has been removed.");
						}
						if(response.data.obj.list && response.data.obj.list.length>0){
							///document.write(JSON.stringify(response.data.obj.list));
							setTreeview(response.data.obj.list);	
						}else{
							setTreeview([]);
						}
						///setSaveBtn(true);        
						return false;
					}else{
						setDeleteDialogShow(false);
						setSeverityAlert("error");
						setShowAlert(true);
						setAlertMessage("Node could not be removed.");			
						return false;
					}
				})
				.catch((error) => {
					console.log("ERROR: ", error);
				})	
			}		
	}
	
	function reloadList(){
		// if(userObj.loginId && userObj.fullName && userObj.token){
		// 	getApiTreeview(userObj.loginId,userObj.fullName,userObj.token);
		// }
	}

	// function tVChild(list){
	// 	if(treeTopicObj.id && treeTopicObj.id>0){
	// 		treeview.children = list;
	// 		setTreeview(treeTopicObj);
	// 	}
	// }

	return (
		<div> 
				<MetaTags>
            		<title>Keywords Treeview</title>
          		</MetaTags>
				
				<Header hamburger={true} pageTitle="Keywords Treeview" />
				{dataLoading?<LinearProgress />:null}

				<Box className='mainBox'>	

							<Grid container spacing={2}>
								<Grid item md={6} xs={12} className='topicBox' >  
								<TextField onChange={event => setKeyword(event.target.value)} value={keyword} placeholder={'Search'} fullWidth size="small" variant="outlined" />
								<List component="nav" style={{maxHeight: '68vh', overflow: 'auto'}} aria-label="secondary mailbox folder">
								{(rows || []).map((row,i)=>(
									<ListItemButton
									selected={selectedIndex === i}
									onClick={(event) => handleListItemClick(event, i, row)}
									key={'t'+i}
									>
										{selectedIndex === i?
										<ListItemIcon>
											<CheckIcon />
										</ListItemIcon>
										:null}  
										<ListItemText primary={row.keywordName} />
									</ListItemButton>
								))}                      
								</List>                    
							</Grid>
							<Grid item md={6} xs={12}>
								{(treeTopicObj && treeTopicObj.title && treeTopicObj.title.length>0)?<div style={{padding: 10, backgroundColor:'#498ce4',color:'#FFF',fontWeight:'bold',marginBottom:10}} >Selected: {treeTopicObj.title}</div>:null}           
								{(treeview && treeview.length>0)?<>
								<TreeviewKeywords treeViewData={treeview} selectTreeTopic={selectTreeTopic} />
								</>
								:null}
							</Grid>
						</Grid>



				</Box>
				
				<Box mt={-6} style={{textAlign:'right'}} >

          {addBtnLoading?
			<LoadingButton loading={addBtnLoading} loadingPosition="start" startIcon={<SaveIcon />} style={{backgroundColor:'#008000',color:'#FFF'}} size="small" variant="contained"  >Adding</LoadingButton>:
			(selectedIndex>-1 && rows[selectedIndex].autoId)?<>
				<Button onClick={()=>{addTopic()}}>Add</Button>
			</>
          :null}
          {(treeview && treeview.length>0 && treeTopicObj && treeTopicObj.title && treeTopicObj.title.length>0)?<>
          <Button onClick={()=>{unselectTopic()}}>Unselect</Button>
          <Button onClick={()=>{editTopic()}}>Edit</Button>
          <Button onClick={()=>{setDeleteDialogShow(true)}}>Remove</Button>
		  <Button onClick={()=>{addBulk()}}>Add Bulk</Button>
          </>:null}

				</Box>

			<TreeviewKeywordSave dataObj={treeTopicObj} tempTreeview={setTreeview} ref={childRefSave} />
			<TreeviewKeywordAddBulk dataObj={treeTopicObj} reloadList={reloadList} ref={childRefAddBulk} />


			<Stack spacing={2} sx={{ width: '100%' }}>
					<Snackbar open={showAlert} autoHideDuration={6000} onClose={hideAlert} anchorOrigin={{vertical,horizontal}}  >
						<Alert onClose={hideAlert} variant="filled" severity={severityAlert} sx={{ width: '100%' }}>
							{alertMessage}
						</Alert>
					</Snackbar>
			</Stack>


				<Dialog
					open={deleteDialogShow}
					onClose={()=>{setDeleteDialogShow(false)}}
					aria-labelledby="alert-dialog-section-title"
					aria-describedby="alert-dialog-section-description"
				>
					<DialogTitle id="alert-dialog-section-title">
						Alert
					</DialogTitle>
					<DialogContent>
					<DialogContentText id="alert-dialog-section-description">
						Are you sure, You want to remove tree node.
					</DialogContentText>
					</DialogContent>
					<DialogActions>
					<Button variant="outlined" size="small" onClick={()=>{setDeleteDialogShow(false)}}>Don't Remove</Button>
					                {deleteBtnLoading?
                          <LoadingButton loading={deleteBtnLoading} loadingPosition="start" startIcon={<SaveIcon />} style={{backgroundColor:'#f60057',color:'#FFF'}} size="small" variant="contained"  >Removing</LoadingButton>
					    	          :<Button variant="contained" size="small" color="secondary" onClick={()=>{deleteTopic()}} autoFocus>Yes, Remove</Button>
                          }
					</DialogActions>
				</Dialog>



				<Authorization ref={childRefAuthorization} />
				
		</div>	
	);
  }